import useFetchOnce, { fetchOnce, isFetchPossible, isFetchRequired } from './useFetchOnce';
import * as loadState from './useLoadState';

export type { FetchPossible, FetchResourceAction, FetchResourceActionCreator } from './useFetchOnce';
export type {
  FirstLoadSelectors,
  LoadSetupStates,
  LoadState,
  LoadStates,
  LoadStatesOptions,
  ResourceCollection,
  ResourceSelectors,
} from './useLoadState';

const { useFirstLoadPending, useLoadState, useLoadStates, useLoadSetupStates } = loadState;

export {
  fetchOnce,
  isFetchPossible,
  isFetchRequired,
  loadState,
  useFetchOnce,
  useFirstLoadPending,
  useLoadSetupStates,
  useLoadState,
  useLoadStates,
};
